import React, { useState } from 'react';
import './css/index.scss';
import { useDispatch } from 'react-redux';
import MyModal from '../../../../components/MyModal';
import { EVENT_MODAL_STATES } from '../../constants';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';
import { removeEvent, updateEvent } from '../../../../store/actions/events';

function EventModal({
  isVisible, setIsVisible, modalState, selectedEvent = {}, setSelectedEvent,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    if (loading) {
      return;
    }
    setIsVisible(false);
    setTimeout(() => {
      setSelectedEvent({});
    }, 400);
  };

  const onActiveChange = (newActiveVal) => async () => {
    const payload = {
      event_id: selectedEvent._id,
      is_active: newActiveVal,
    };

    const data = await sendRequest({
      request: Api.blockEvent,
      payload,
      warnErrorText: 'while blocking event',
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(updateEvent({ ...selectedEvent, is_active: newActiveVal }));
      closeModal();
    }
  };

  const onDeleteClick = async () => {
    const data = await sendRequest({
      request: Api.deleteEvent,
      payload: { id: selectedEvent._id },
      warnErrorText: 'while deleting event',
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(removeEvent({ ...selectedEvent }));
      closeModal();
    }
  };

  return (
    <MyModal isOpen={isVisible} closeFunction={closeModal}>
      <div className="event_modal">
        {modalState === EVENT_MODAL_STATES.block ? (
          <>
            <p className="modal_title">Забанить?</p>
            <p className="modal_info_name">{selectedEvent.name}</p>
            <p className="modal_info">Вы уверены что хотите отправить это мероприятие в бан-лист?</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Забанить"
                loading={loading}
                onClick={onActiveChange(false)}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.fullyDelete ? (
          <>
            <p className="modal_title">Удалить?</p>
            <p className="modal_info_name">{selectedEvent.name}</p>
            <p className="modal_info">Вы уверены что хотите удалить это мероприятие?</p>
            <p className="modal_info">Отменить данное действие будет невозможно</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Удалить"
                loading={loading}
                onClick={onDeleteClick}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.makeActive ? (
          <>
            <p className="modal_title">Разбанить?</p>
            <p className="modal_info_name">{selectedEvent.name}</p>
            <p className="modal_info">Вы уверены что хотите снять это мероприятие из бан-листа?</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Разбанить"
                loading={loading}
                onClick={onActiveChange(true)}
              />
            </div>
          </>
        ) : modalState === EVENT_MODAL_STATES.changeData ? (
          <>myau</>
        )
          : null}

      </div>
    </MyModal>
  );
}

export default EventModal;
